import { createContext } from "react";

import type { FeatureToggleContextValue } from "./FeatureToggleContextValue";

export const FeatureToggleContext = createContext<FeatureToggleContextValue | null>(null);

FeatureToggleContext.displayName = "FeatureToggleContext";
